<template>
  <b-card title="ผลการค้นหา">
    <!-- search input -->
    <div class="custom-search d-flex justify-content-end">
      <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1">Search</label>
          <b-form-input
            v-model="searchTerm"
            placeholder="Search"
            type="text"
            class="d-inline-block"
          />
        </div>
      </b-form-group>
    </div>

    <!-- table -->
    <vue-good-table
      :columns="columns"
      :rows="rows"
      :rtl="direction"
      :line-numbers="true"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm,
      }"
      :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: false, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }"
      :pagination-options="{
        enabled: true,
        perPage: pageLength,
      }"
      @on-page-change="onPageChange"
      @on-per-page-change="onPageLengthChange"
      :totalRows="totalRecords"
    >
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field === 'name'" class="text-nowrap">
          <span class="text-nowrap"
            >{{ props.row.juristicNameTh }}
            {{
              props.row.headoffice == false ? props.row.juristicBranchTh : ""
            }}</span
          >
        </span>

        <span v-if="props.column.field === 'juristicId'" class="text-nowrap">
          <span class="text-nowrap">{{ props.row.juristicId }}</span>
        </span>

        <!-- Column: Action -->
        <span v-else-if="props.column.field === 'action'">
          <span>
            <b-button
              @click="onManageBtnClicked(props.row.compId)"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-primary"
              class="text-body align-middle mr-25"
            >
              <feather-icon icon="UsersIcon" class="mr-50" />
              <span class="align-middle"
                >({{ props.row.attorneyCount }}) ผู้รับมอบอำนาจ</span
              >
            </b-button>
          </span>
        </span>
      </template>

      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
              แสดง 1 ถึง
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['10', '25', '50']"
              class="mx-1"
              @input="
                (value) => props.perPageChanged({ currentPerPage: value })
              "
            />
            <span class="text-nowrap"> จาก {{ props.total }} รายการ </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  </b-card>
</template>

<script>
import {
  BButton,
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BCard,
  BCardHeader,
  BCardBody,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import Ripple from "vue-ripple-directive";
import store from "@/store/index";
import { codeBasic } from "@/views/table/vue-good-table/code";
import TableHeaders from "./commonTableHeader.js";

import * as ComplaintAPI from "@/store/api/complaint/complaint.js";
import * as getOauth from "@/store/api/axiosUtils.js";
// import { axiosGetOAuth } from "@/store/api/axiosUtils.js";
import * as userData from "@/auth/localStorageUtils.js";
import * as companyStore from "@/store/api/company/index.js";
import appsettings from "@/store/app-settings";

export default {
  directives: {
    Ripple,
  },
  components: {
    VueGoodTable,
    BButton,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BCard,
    BCardHeader,
    BCardBody,
    TableHeaders,
    ComplaintAPI,
  },
  props: {
    routeName: String,
  },
  data() {
    return {
      pageLength: 10,
      dir: false,
      codeBasic,
      columns: TableHeaders,
      rows: [],
      searchTerm: "",
      totalRecords: 0,
      status: [
        {
          1: "Current",
          2: "Professional",
          3: "Rejected",
          4: "Resigned",
          5: "Applied",
        },
        {
          1: "light-primary",
          2: "light-success",
          3: "light-danger",
          4: "light-warning",
          5: "light-info",
        },
      ],
    };
  },
  computed: {
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Current: "light-primary",
        Professional: "light-success",
        Rejected: "light-danger",
        Resigned: "light-warning",
        Applied: "light-info",
        /* eslint-enable key-spacing */
      };

      return (status) => statusColor[status];
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
  },
  created() {
    this.onSearchSubmit({});
  },
  methods: {
    onPageChange(page) {
      console.log("onPageChanged", page);
      this.onSearchSubmit(this.params, page);
    },
    onPageLengthChange(pageLength) {
      console.log("onPageLengthChanged", pageLength);
      this.onSearchSubmit(this.params, 1);
    },
    onSearchSubmit(params, page = { currentPage: 1 }) {
      var _this = this;

      params.page = page.currentPage;
      params.pageSize = this.pageLength;

      _this.params = params;

      _this.$emit("handleOverlay", true);

      companyStore
        .getPagination(params)
        .then(function(response) {
          // handle success
          _this.rows = response.data.data;
          try {
            _this.totalRecords = response.data.total;
          } catch (ex) {
            console.log("get total records error", ex);
            _this.totalRecords = 0;
          }
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
          _this.rows = [];
          _this.totalRecords = 0;
        })
        .then(function() {
          // always executed
          _this.$emit("handleOverlay", false);
        });
    },
    onManageBtnClicked(id) {
      window.open(
        this.$router.resolve({
          name: "FasttrackUserInspectAttorney",
          query: { id },
        }).href,
        "_blank",
      );

      return;
      var _this = this;

      // parameter for get code authorize
      const paramAuthorize = {
        officerId: userData.userId(),
        customerId: userId,
        redirect_uri: encodeURIComponent(
          appsettings.complaintLoginCustomerByOfficer + userData.userId(),
        ),
        // redirect_uri: 'xxx'
      };
      console.log("paramAuthorize", paramAuthorize);

      // header api
      const headerAuthorize = appsettings.oauthKey.clientId;
      console.log("headers", appsettings.oauthKey.clientId);

      // url api
      // const urlAuthorize = userStore.urlAuthorizeByOfficer();
      const urlAuthorizeMain =
        appsettings.digtalIdOauthUrl + "oauth/authorizeByOfficer?";
      const urlAuthorizeParam =
        "officerId=" +
        paramAuthorize.officerId +
        "&customerId=" +
        paramAuthorize.customerId +
        "&redirect_uri=" +
        paramAuthorize.redirect_uri;

      getOauth
        // .axiosGetOAuth_V2(urlAuthorize)
        .axiosGetOAuth_V2(urlAuthorizeMain + urlAuthorizeParam, headerAuthorize)
        .then(function(response) {
          // handle success
          var urlLogin = response.data.response_uri;
          console.log("urlLogin", urlLogin);

          if (urlLogin != null) {
            window.open(urlLogin, "_blank");
          }
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        })
        .then(function() {
          // always executed
          _this.$emit("handleOverlay", false);
        });
    },
  },
};
</script>
